import {observer} from "mobx-react-lite";
import React, {useEffect} from "react";
import Game from "../../Games/Game";
import {useParams} from 'react-router'
import clubStore from '../../../storage/ClubStore'

const EditGame = () => {
  const args = useParams();
  useEffect(() => {
    clubStore.tournament.getGame(args.id)
  }, [args.id])
  return (
    <Game/>
  )
}
export default observer(EditGame)